import { BackUpCodesModal } from "./backUpCodesModal";
import { EnterVerificationCodeModal } from "./enterVerificationCodeModal";

export const ProfileModalRoot = ({
  activeModal,
  modal,
  modalOpen,
  handleModalClose,
  handleModalOpen,
}: {
  activeModal: string | null;
  modal: string | null;
  modalOpen: boolean;
  handleModalClose: () => void;
  handleModalOpen: (name: string) => void;
}) => {
  return (
    <>
      {modal === "enterVerificationCode" && (
        <EnterVerificationCodeModal
          open={modalOpen}
          handleClose={handleModalClose}
          handleModalOpen={handleModalOpen}
          onSuccess={() => {
            console.log("2FA Success");
          }}
        />
      )}

      {modal === "backupCodesModal" && (
        <BackUpCodesModal
          open={modalOpen}
          handleClose={handleModalClose}
          onSuccess={() => {
            console.log("Backup Codes Success");
          }}
        />
      )}
    </>
  );
};
